import React from "react";

type SearchNominaProps = {
  placeholder?: string;
  delayMs?: number;
  onChangeDebounced: (value: string) => void;
  onClearImmediate?: () => void;
  defaultValue?: string;
  className?: string;
};

const SearchNomina: React.FC<SearchNominaProps> = ({
  placeholder = "Buscar...",
  delayMs = 300,
  onChangeDebounced,
  onClearImmediate,
  defaultValue = "",
  className,
}) => {
  const [value, setValue] = React.useState(defaultValue);
  const [isFocused, setIsFocused] = React.useState(false);
  const timerRef = React.useRef<any>(null);
  const containerRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, []);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setValue(newValue);

    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    if (newValue === "") {
      onClearImmediate && onClearImmediate();
      return;
    }

    timerRef.current = setTimeout(() => {
      onChangeDebounced(newValue.toLowerCase());
      timerRef.current = null;
    }, delayMs);
  };

  const handleClear = () => {
    setValue("");
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
    onClearImmediate && onClearImmediate();
  };

  React.useEffect(() => {
    if (containerRef.current) {
      if (isFocused) {
        containerRef.current.style.borderColor = "#9ca3af";
        containerRef.current.style.boxShadow =
          "0 0 0 3px rgba(107, 114, 128, 0.1)";
      } else {
        containerRef.current.style.borderColor = "#e5e7eb";
        containerRef.current.style.boxShadow = "none";
      }
    }
  }, [isFocused]);

  return (
    <div
      ref={containerRef}
      className={`input-group ${className || ""}`.trim()}
      style={{
        maxWidth: "500px",
        borderRadius: "12px",
        overflow: "hidden",
        border: "1px solid #e5e7eb",
        backgroundColor: "white",
        transition: "all 0.2s ease-in-out",
      }}
      onMouseEnter={(e) => {
        if (!isFocused) {
          e.currentTarget.style.borderColor = "#d1d5db";
          e.currentTarget.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.05)";
        }
      }}
      onMouseLeave={(e) => {
        if (!isFocused) {
          e.currentTarget.style.borderColor = "#e5e7eb";
          e.currentTarget.style.boxShadow = "none";
        }
      }}
    >
      <span
        className="input-group-text border-0 bg-transparent"
        aria-hidden
        style={{
          padding: "0.75rem 1rem",
          color: "#6b7280",
        }}
      >
        <i
          className="fa-solid fa-magnifying-glass"
          style={{ fontSize: "0.875rem" }}
        ></i>
      </span>
      <input
        type="text"
        className="form-control border-0"
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        aria-label={placeholder}
        style={{
          padding: "0.75rem 0",
          fontSize: "0.95rem",
          border: "none",
          boxShadow: "none",
          backgroundColor: "transparent",
          color: "#374151",
        }}
      />
      {value && (
        <button
          type="button"
          className="btn border-0 bg-transparent"
          onClick={handleClear}
          aria-label="Limpiar búsqueda"
          style={{
            padding: "0.75rem 1rem",
            color: "#9ca3af",
            transition: "all 0.2s ease-in-out",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.color = "#6b7280";
            e.currentTarget.style.backgroundColor = "#f3f4f6";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.color = "#9ca3af";
            e.currentTarget.style.backgroundColor = "transparent";
          }}
        >
          <i className="fa-solid fa-xmark" style={{ fontSize: "0.75rem" }}></i>
        </button>
      )}
    </div>
  );
};

export default SearchNomina;
